var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapsedIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 23.1488,
    height: 21.6816,
    transform: "matrix(1 0 0 -1 0 21.6816)",
    fill: "#EAEAEA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 23.1488,
    height: 21.6816,
    transform: "matrix(1 0 0 -1 0 21.6816)",
    stroke: "#0057B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9712 8.22263C18.2081 8.46863 18.2081 8.86648 17.9712 9.11188L12.9515 14.3131C12.8409 14.4296 12.7077 14.5223 12.5601 14.5856C12.4125 14.649 12.2536 14.6816 12.0929 14.6816C11.9323 14.6816 11.7734 14.649 11.6258 14.5856C11.4782 14.5223 11.345 14.4296 11.2344 14.3131L6.17767 9.07422C6.06466 8.95532 6.00114 8.79786 6.00002 8.63383C5.99889 8.4698 6.06023 8.31148 6.1716 8.19104C6.22659 8.13138 6.29325 8.08364 6.36745 8.05078C6.44164 8.01792 6.52179 8.00064 6.60293 8.00002C6.68407 7.99939 6.76448 8.01543 6.83917 8.04714C6.91386 8.07885 6.98125 8.12555 7.03716 8.18436L11.6638 12.9793C11.7191 13.0375 11.7857 13.0839 11.8596 13.1156C11.9334 13.1473 12.0129 13.1637 12.0932 13.1637C12.1736 13.1637 12.2531 13.1473 12.3269 13.1156C12.4008 13.0839 12.4674 13.0375 12.5227 12.9793L17.1129 8.22263C17.1682 8.16438 17.2347 8.118 17.3085 8.0863C17.3823 8.05461 17.4617 8.03826 17.542 8.03826C17.6223 8.03826 17.7018 8.05461 17.7756 8.0863C17.8493 8.118 17.9159 8.16438 17.9712 8.22263Z",
    fill: "#0057B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapsedIco);
export default __webpack_public_path__ + "static/media/collapsed--ico.79a44ee2299e3c82219b7e1ea11b98bf.svg";
export { ForwardRef as ReactComponent };